import React, { useCallback, useEffect, useState } from "react";
import { Box} from "@chakra-ui/react";
import './organizationBank.css'; 
import ColumnTable from "../embrillTable/ColumnTable";
import { useDispatch, useSelector } from "react-redux";
import { AiFillDelete, AiFillEye } from "react-icons/ai";
import EmbrillProfileInfoModel from "components/models/EmbrillProfileInfoModal";
import { fetchAsyncGetEmbrillProfile } from "redux/embrillProfileSlice";
import { fetchAsyncDeleteEmbrillProfile } from "redux/embrillProfileSlice";
import { RiFileExcel2Fill } from "react-icons/ri";
import { FaPlus } from "react-icons/fa";
import { MdModeEdit } from "react-icons/md";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import orgJson from "components/jsonData/orgnization.json"; 
import OrganizationBankForm from "components/allForm/OrganizationBank/orgBank";
import { bankDataColumns } from "../embrillTable/variables/orgBank";
import AccountDetail from "components/allForm/OrganizationBank/accountDetails";
import StatementDetails from "./statementDetails";
import TransactionDetails from "./transactionDetails";
import { fetchAsyncGetAutomatedBank } from "redux/embrillProfileSlice";
import useSearch from "hooks/useSearch";
import StatementValidate from "./statementValidate";
import { togglePrimaryBank } from "redux/embrillProfileSlice";
import { useToasts } from "react-toast-notifications";

const OrganizationBank = () => {
  const dispatch = useDispatch();
  const [embrillProfileListData, setEmbrillProfileListData] = useState([]);
  const [accountData, setAccountData] = useState({});
  const [loading, setLoading] = useState(false);
  const [activeTab,setActiveTab] = useState('automated')
  const [subActiveTab,setSubActiveTab] = useState('account')
  const currUser = useSelector((state) => state.auth.currUser);
  const [role, setRole] = useState("");
  const { searchText } = useSelector((state) => state.searchValue);
  const [openEmbrillProfileModal, setOpenEmbrillProfileModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [embrillProfileEditData, setEmbrillProfileEditData] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [openEmbrillProfileInfoModel, setOpenEmbrillProfileInfoModel] = useState(false);
  const { performSearch } = useSearch();
  const { addToast } = useToasts();

  useEffect(() => {
    if (currUser && currUser?.auth) {
      const auth = currUser?.auth;
      const roleObj =
        auth &&
        auth?.length > 0 &&
        auth.find((item) => item?.module === "Organization Bank");
      if (roleObj) {
        setRole(roleObj?.access);
      }
    }
  }, [currUser]);

  const getBankDetails = ()=>{
    dispatch(fetchAsyncGetAutomatedBank())
      .then((res) => {
        if(res?.payload && res?.payload?._id){
          setAccountData(res?.payload)
        }
      })
  }

  const handleOpenEmbrillProfileModal = () => {
    setOpenEmbrillProfileModal(true);
  };

  const handleCloseEmbrillProfileModal = () => {
    setOpenEmbrillProfileModal(false);
    setOpenEditModal(false);
    setEmbrillProfileEditData(null);
    handlerRefreshData();
  };
  const handlerRefreshData = useCallback(() => {
    performSearch(searchText);
  }, [searchText,performSearch]);

  const embrillProfileList = useSelector((state) => state.embrillProfileData);

  const deleteEmbrillProfile = (data) => {
    fetchAsyncDeleteEmbrillProfile(data._id).then(() => {
      handlerRefreshData();
    }).catch(e => e?.message && addToast(e?.message, {appearance: "error"}));
  };

  /**
   * 
   * @param {React.MouseEvent<HTMLInputElement, MouseEvent>} e 
   * @param {{_id: string}} data 
   */
  const handleTogglePrimaryBank = async (e, data) => {
    e.stopPropagation();
    try {
      await togglePrimaryBank(data._id, e.target.checked);
    } catch (error) {
      if (typeof error?.message === "string") {
        addToast(error?.message, {
          appearance: "error"
        })
      }
    }

    handlerRefreshData();
  }

  useEffect(() => {
    if (embrillProfileList && embrillProfileList.length > 0) {
      const tableData = embrillProfileList.map((data, index) => {
        return {
          _id: data._id,
          no: index + 1,

          accountNumber: <span>{data?.acNo}</span>,
          ifscCode: <span>{data?.ifc}</span>,
          branchName: <span>{data?.bch}</span>,

          aliasName: <span>{data?.aliasName}</span>,
          bankName: (
            <span style={{ cursor: "pointer", color: "blue" }}>
              {data?.bnk}
            </span>
          ),
          attachePayment: (
            <div class="position-relative">
              <RiFileExcel2Fill size={20} />
              <span className="position-absolute top-0 start-100 translate-middle badge  bg-primary text-white">
                {data?.exDts && data?.exDts?.length
                  ? data?.exDts?.length
                  : 0}
              </span>
            </div>
          ),
          isPrimary: (
            <input
              onClick={(e) => handleTogglePrimaryBank(e, data)}
              type="checkbox"
              checked={data.isPrimary}
            />
          ),
          contactPerson: data?.cnctPsn,
          action: (
            <div className="d-flex">
              <MdModeEdit
                className="me-2"
                color="blue"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  handleRowClick(e, data._id);
                }}
              />
              <AiFillEye
                className="me-2"
                color="#000D55"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedItem(data);
                  setOpenEmbrillProfileInfoModel(true);
                }}
              />
              {role === "Admin" ? (
                <AiFillDelete
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                  size={16}
                  onClick={(e) => {
                    e.preventDefault();
                    ConfirmationDialog({
                      title: orgJson.confirm.delete,
                      text: orgJson.text.undone,
                      icon: "warning",
                      confirmButtonText: "delete",
                      cancelButtonText: "Cancel",
                      onConfirm: () => {
                        deleteEmbrillProfile(data);
                      },
                    });
                  }}
                />
              ) : (
                "No Access"
              )}
            </div>
          ),
        };
      });
      setEmbrillProfileListData(tableData);
    } else {
      setEmbrillProfileListData([]);
    }
  }, [embrillProfileList]);

  const handleRowClick = (e, _id) => {
    e.stopPropagation();
    const data = embrillProfileList.filter((item) => item?._id === _id);
    setOpenEditModal(true);
    setEmbrillProfileEditData(data[0]);
    handleOpenEmbrillProfileModal();
  };

  const closeEmrillProfileInfoModal = () => {
    setOpenEmbrillProfileInfoModel(false);
    setSelectedItem({});
  };

  useEffect(() => {
    setLoading(true);
    dispatch(fetchAsyncGetEmbrillProfile())
      .then(() => {
        setLoading(false); 
      })
      .catch((error) => {
        setLoading(false);
      });
      getBankDetails();
  }, []);

  if (loading) {
    return <SpinnerLoader />;
  }
  return (
    <>
      <Box className="organization-bank-profile">
        <div className="heading">

        <Box display="flex"  className="tab-btn organization-bank">
        
        <Box className="tab-btn-div">
        <div
            className={`div-btn ${
              activeTab === "automated" ? "active-tab-btn" : ""
            }`}
            onClick={() => setActiveTab("automated")}
          >
            Automated 
          </div>
          <div
            className={`div-btn ${
              activeTab === "manual" ? "active-tab-btn" : ""
            }`}
            onClick={() => setActiveTab("manual")}
          >
            Manual
          </div>
         
        </Box>
      
      </Box>
        </div>
      {activeTab === 'automated' &&
      <>
         <div className="form-data account-user">
      <Box display="flex"  className="tab-btn organization-bank">
        
        <Box className="tab-btn-div">
        <div
            className={`div-btn ${
              subActiveTab === "account" ? "active-tab-btn" : ""
            }`}
            onClick={() => setSubActiveTab("account")}
          >
            Account Details
          </div>
          <div
            className={`div-btn ${
              subActiveTab === "statement" ? "active-tab-btn" : ""
            } ${!accountData?._id ? "disabled-field" : ""}`}
          
            onClick={() => accountData?._id && setSubActiveTab("statement")}
          >
            Account Statement
          </div>
          <div
            className={`div-btn ${
              subActiveTab === "statementValidate" ? "active-tab-btn" : ""
            } ${!accountData?._id ? "disabled-field" : ""}`}
          
            onClick={() => accountData?._id && setSubActiveTab("statementValidate")}
          >
            Statement Validate
          </div>
          <div
              className={`div-btn ${
                subActiveTab === "transaction" ? "active-tab-btn" : ""
              }`}
              onClick={() => setSubActiveTab("transaction")}
            >
              Transactions
            </div>
        </Box>
      
      </Box>
        {subActiveTab === 'account' &&
         <AccountDetail role={role}/>
        }
         </div>
         {subActiveTab === 'statement' &&
         <StatementDetails/>
         }
         {subActiveTab === 'statementValidate' &&
         <StatementValidate/>
         }
         {subActiveTab === 'transaction' &&
         <TransactionDetails/>
         }
      </>
      }
      {activeTab === 'manual' &&
      <>
        <Box display="flex" mr={2} className="add-new-btn m-3" justifyContent="end">
          <Box
            display="flex"
            alignItems="center"
            className="new-btn"
            onClick={handleOpenEmbrillProfileModal}
          >
            <FaPlus size={12} className="new-plus-icon" /> New
          </Box>
        </Box>
      <Box>
        <ColumnTable
          columnsData={bankDataColumns}
          tableData={embrillProfileListData}
          type={"Organization Bank"}
          role={role}
          expenseType="organization-bank"
          openInfoModal={handleRowClick}
        />
      </Box>
      {openEmbrillProfileModal && (
        <OrganizationBankForm
          openModal={openEmbrillProfileModal}
          closeModal={handleCloseEmbrillProfileModal}
          isEditForm={openEditModal}
          editItem={embrillProfileEditData}
          role={role}
          refreshEditData={handlerRefreshData}
        />
      )}
      {openEmbrillProfileInfoModel && (
        <EmbrillProfileInfoModel
          openInfoModal={openEmbrillProfileInfoModel}
          closeInfoModal={closeEmrillProfileInfoModal}
          selectedData={selectedItem}
          role={role}
        />
      )}
      </>
      }
      </Box>
    </>
  );
};

export default OrganizationBank;
